export default __webpack_public_path__ + "static/media/MDI - youtube.b279f9e6.svg";